module.exports = __webpack_public_path__ + "static/media/sign-in-background.f4d526dc.png";